/*
 * @Author: zhujian 
 * @Date: 2019-08-13 12:39:37 
 * @Last Modified by: zhujian
 * @Last Modified time: 2019-09-11 14:07:34
 */


declare var window: any

class User {
  uid() {
    return localStorage.getItem('uid');
  }

  token() {
    return localStorage.getItem('token');
  }

  adminName() {
    return localStorage.getItem('adminName');
  }

  phone() {
    return localStorage.getItem('uPhone');
  }

  aid() {
    return localStorage.getItem('aid');
  }

  cid() {
    return localStorage.getItem('cid');
  }

}

export default new User();